import styled from "styled-components";
import { theme } from "../../../theme/GlobalTheme";

export const FlexContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: stretch;
  flex-wrap: wrap;
  gap: ${theme.spacing.xxl};
  padding: ${theme.spacing.lg};
  max-width: 1200px;
  margin: 0 auto;
  width: 100%;
`;

// Base container styling
const baseContainerStyles = `
  display: flex;
  flex: 1;
  flex-direction: column;
  margin: 0;
  width: 100%;
  max-width: 500px;
  background-color: ${theme.colors.white};
  border: 1px solid ${theme.colors.primary};
  border-radius: ${theme.borderRadius.large};
  box-shadow: ${theme.shadows.card};
  padding: ${theme.spacing.xl};
`;

export const Container = styled.div`
  ${baseContainerStyles}
  justify-content: space-between;
`;

// Container for project info - keeps content at top
export const ProjectInfoContainer = styled.div`
  ${baseContainerStyles}
  justify-content: flex-start;
`;


export const Loading = styled(Container)`
`;

export const NotFound = styled(Container)`
`;

export const Title = styled.h3`
  font-size: ${theme.typography.fontSize.h3};
  color: ${theme.colors.primary};
  font-family: ${theme.typography.fontFamily};
  font-weight: ${theme.typography.fontWeight.bold};
  margin: 0 0 ${theme.spacing.lg} 0;
  text-align: left;
`;

export const Description = styled.p`
  font-size: ${theme.typography.fontSize.body};
  color: ${theme.colors.text};
  font-family: ${theme.typography.fontFamily};
  line-height: 1.5;
  margin: 0 0 ${theme.spacing.sm} 0;
`;

export const Highlight = styled.span`
  font-weight: ${theme.typography.fontWeight.bold};
  color: ${theme.colors.textPrimary};
`;

export const Button = styled.button`
  border: none;
  background-color: ${theme.colors.primary};
  color: ${theme.colors.white};
  width: 100%;
  text-align: center;
  padding: 15px;
  font-size: ${theme.typography.fontSize.body};
  font-family: ${theme.typography.fontFamily};
  font-weight: ${theme.typography.fontWeight.bold};
  border-radius: ${theme.borderRadius.medium};
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  margin-top: ${theme.spacing.lg};

  &:hover {
    background-color: ${theme.colors.secondary};
    transform: translateY(-1px);
    box-shadow: ${theme.shadows.light};
  }

  &:active {
    transform: translateY(0);
  }
`;

export const ConfigurationList = styled.ul`
  margin: 0 0 ${theme.spacing.md} 0;
  padding-left: ${theme.spacing.lg};
  list-style-type: disc;
`;

export const ConfigurationItem = styled.li`
  margin-bottom: ${theme.spacing.sm};
  font-size: ${theme.typography.fontSize.body};
  color: ${theme.colors.text};
  font-family: ${theme.typography.fontFamily};
  line-height: 1.5;
`;

export const ConfigurationLink = styled.a`
  color: ${theme.colors.primary};
  text-decoration: none;
  font-weight: ${theme.typography.fontWeight.bold};
  transition: color 0.2s ease-in-out;

  &:visited {
    color: ${theme.colors.primary};
  }

  &:hover {
    color: ${theme.colors.secondary};
    text-decoration: underline;
  }
`;
